export const Fechas = {
    diasDesdeRetiro: 30
}
  
export default Fechas;